import React, { useEffect, useState } from 'react';
import style from "./css/DashBoardPage.module.css";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
    apiURL_BACKEND,
    PackagePassInterface,
    UserDataInterface,
    webUrl,
    useJustifyUserType,
    botUsername,
    AgentPackage,
    PackageInterface,
    formatTitleText,
    userPackageInterface

} from './Vars';
interface DashBoardProps {

}



const DashBoardPage: React.FC<DashBoardProps> = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState<UserDataInterface>();
    // const [packagePasses, setPackagePasses] = useState<PackagePassInterface[]>([]);

    const userType = useJustifyUserType();

    useEffect(() => {


        const res = axios.get(`${apiURL_BACKEND}/getUser/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            var data = res.data;
            // console.log(data);

            setUserData({
                username: data.username,
                email: data.email,
                referrer: data.referrer,
                refer_code: data.refer_code,
                date_joined: data.date_joined,
                package: data.package,
                balance: data.balance,
                user_type: data.user_type,
                tme_username: data.tme_username
            })
            // console.log("Package type ---> ", data.package);
        }).catch((err) => {
            console.error("API Error:", err?.response?.status, err?.response?.data);
            navigate('/'); // Redirects without showing an error popup
        });


        // setUserData({
        //     username:res.
        // })
    }, [])




    const [tmeLoginStr, setTmeAuth] = useState<string>("")
    useEffect(
        () => {
            axios.post(`${apiURL_BACKEND}/getUserLoginID_Telegram/`, {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    },
                }
            ).then(
                (res) => {
                    // console.log(res);
                    setTmeAuth(res.data.str);
                }
            )
        }, []
    )

    const buyPlan = (type: string, productID: number) => {
        navigate(`/checkout/?type=${type}&productID=${productID}`);
    }



    const [copied, setCopied] = useState(false);
    useEffect(() => {
        if (copied) {
            alert("Copied !");
        }
    }, [copied]);

    const handleCopy = async (element_id: string) => {
        try {

            var el = document.getElementById(element_id);
            if (el) {
                var textToCopy = el.innerText;
                navigator.clipboard.writeText(textToCopy);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            }


        } catch (err) {
            console.error("Failed to copy text:", err);
        }
    };


    const [agentPackages, setAgentPackages] = useState<Array<AgentPackage>>([]);
    useEffect(() => {
        axios.get(`${apiURL_BACKEND}/getAgentPackages/`).then((res) => {
            const data = res.data;
            setAgentPackages(data.packages);
        }).catch((err) => { console.log(err) })
    }, [])


    const [allPackages, setAllPackages] = useState<Array<PackageInterface>>([]);
    const [package_types, set_package_types] = useState([]);
    const [sport_types, set_sport_types] = useState([]);
    useEffect(() => {
        console.log("all packages")
        axios.get(`${apiURL_BACKEND}/getAllPackages/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            const data = res.data;
            setAllPackages(JSON.parse(data.packages));
            // console.log("all packages ", res.data);
        }).catch((err) => { console.log(err); })
    }, [])

    const [activePackages, setActivePackages] = useState<Array<userPackageInterface>>([]);
    useEffect(() => {
        axios.get(`${apiURL_BACKEND}/getActivePackages/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            const data = res.data;
            setActivePackages(JSON.parse(data.packages));
            

        }).catch((err) => { console.log(err) })
    }, [])
    useEffect(()=>{
        console.log(activePackages);
    },[activePackages])
    return (
        <>
            <div className={style.dashboard}>
                <div className={style.pseudoSideNav}>

                </div>
                <div className={style.dashboardMain}>


                    <div className={style.profileInfo}>
                        <img className={style.profileInfo_img} src="/media/profile-picture.png" alt="" />
                        <p className={style.profileName}>{userData?.email}</p>
                        <p className={style.username}>@{userData?.username}</p>
                    </div>


                    <div className={style.personalInformationCard}>
                        <p className={style.personalInfoTitle}>
                            PERSONAL INFORMATIONS
                        </p>
                        <p className={style.pInfot1}>Member since &nbsp; &nbsp; {userData?.date_joined}</p>

                        <form action="" className={style.userDataForm}>
                            <div className={style.userDataFormData}>
                                <label htmlFor="" className={style.userDataFormData_label}>
                                    <p>Name</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M1.33333 10.6667H2.28333L8.8 4.15L7.85 3.2L1.33333 9.71667V10.6667ZM0 12V9.16667L8.8 0.383333C8.93333 0.261111 9.08056 0.166667 9.24167 0.1C9.40278 0.0333333 9.57222 0 9.75 0C9.92778 0 10.1 0.0333333 10.2667 0.1C10.4333 0.166667 10.5778 0.266667 10.7 0.4L11.6167 1.33333C11.75 1.45556 11.8472 1.6 11.9083 1.76667C11.9694 1.93333 12 2.1 12 2.26667C12 2.44444 11.9694 2.61389 11.9083 2.775C11.8472 2.93611 11.75 3.08333 11.6167 3.21667L2.83333 12H0ZM8.31667 3.68333L7.85 3.2L8.8 4.15L8.31667 3.68333Z" fill="#A4AFB8" />
                                    </svg>
                                </label>
                                <input type="text" value={userData?.username} />
                            </div>

                            <div className={style.userDataFormData}>
                                <label htmlFor="" className={style.userDataFormData_label}>
                                    <p>UserName</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M1.33333 10.6667H2.28333L8.8 4.15L7.85 3.2L1.33333 9.71667V10.6667ZM0 12V9.16667L8.8 0.383333C8.93333 0.261111 9.08056 0.166667 9.24167 0.1C9.40278 0.0333333 9.57222 0 9.75 0C9.92778 0 10.1 0.0333333 10.2667 0.1C10.4333 0.166667 10.5778 0.266667 10.7 0.4L11.6167 1.33333C11.75 1.45556 11.8472 1.6 11.9083 1.76667C11.9694 1.93333 12 2.1 12 2.26667C12 2.44444 11.9694 2.61389 11.9083 2.775C11.8472 2.93611 11.75 3.08333 11.6167 3.21667L2.83333 12H0ZM8.31667 3.68333L7.85 3.2L8.8 4.15L8.31667 3.68333Z" fill="#A4AFB8" />
                                    </svg>
                                </label>
                                <input type="text" value={userData?.username} />
                            </div>

                            <div className={style.userDataFormData} >
                                <label htmlFor="" className={style.userDataFormData_label}>
                                    <p>Email ID</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M1.33333 10.6667H2.28333L8.8 4.15L7.85 3.2L1.33333 9.71667V10.6667ZM0 12V9.16667L8.8 0.383333C8.93333 0.261111 9.08056 0.166667 9.24167 0.1C9.40278 0.0333333 9.57222 0 9.75 0C9.92778 0 10.1 0.0333333 10.2667 0.1C10.4333 0.166667 10.5778 0.266667 10.7 0.4L11.6167 1.33333C11.75 1.45556 11.8472 1.6 11.9083 1.76667C11.9694 1.93333 12 2.1 12 2.26667C12 2.44444 11.9694 2.61389 11.9083 2.775C11.8472 2.93611 11.75 3.08333 11.6167 3.21667L2.83333 12H0ZM8.31667 3.68333L7.85 3.2L8.8 4.15L8.31667 3.68333Z" fill="#A4AFB8" />
                                    </svg>
                                </label>
                                <input type="text" value={userData?.email} />
                            </div>

                        </form>


                    </div>



                    <div className={style.personalInformationCard}>
                        <p className={style.personalInfoTitle}>
                            Other INFORMATIONS
                        </p>

                        <form action="" className={style.userDataForm}>
                            <div className={style.userDataFormData}>
                                <label htmlFor="" className={style.userDataFormData_label}>
                                    <p>Preferred Language</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M1.33333 10.6667H2.28333L8.8 4.15L7.85 3.2L1.33333 9.71667V10.6667ZM0 12V9.16667L8.8 0.383333C8.93333 0.261111 9.08056 0.166667 9.24167 0.1C9.40278 0.0333333 9.57222 0 9.75 0C9.92778 0 10.1 0.0333333 10.2667 0.1C10.4333 0.166667 10.5778 0.266667 10.7 0.4L11.6167 1.33333C11.75 1.45556 11.8472 1.6 11.9083 1.76667C11.9694 1.93333 12 2.1 12 2.26667C12 2.44444 11.9694 2.61389 11.9083 2.775C11.8472 2.93611 11.75 3.08333 11.6167 3.21667L2.83333 12H0ZM8.31667 3.68333L7.85 3.2L8.8 4.15L8.31667 3.68333Z" fill="#A4AFB8" />
                                    </svg>
                                </label>
                                <input type="text" value={"undefined"} />
                            </div>

                            <div className={style.userDataFormData}>
                                {
                                    userData?.tme_username && userData.tme_username.length > 0 ? (
                                        <>
                                            <label htmlFor="" className={style.userDataFormData_label}>
                                                <p>Telegram Username</p>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M1.33333 10.6667H2.28333L8.8 4.15L7.85 3.2L1.33333 9.71667V10.6667ZM0 12V9.16667L8.8 0.383333C8.93333 0.261111 9.08056 0.166667 9.24167 0.1C9.40278 0.0333333 9.57222 0 9.75 0C9.92778 0 10.1 0.0333333 10.2667 0.1C10.4333 0.166667 10.5778 0.266667 10.7 0.4L11.6167 1.33333C11.75 1.45556 11.8472 1.6 11.9083 1.76667C11.9694 1.93333 12 2.1 12 2.26667C12 2.44444 11.9694 2.61389 11.9083 2.775C11.8472 2.93611 11.75 3.08333 11.6167 3.21667L2.83333 12H0ZM8.31667 3.68333L7.85 3.2L8.8 4.15L8.31667 3.68333Z" fill="#A4AFB8" />
                                                </svg>
                                            </label>
                                            <input type="text" value={userData.tme_username} />
                                        </>
                                    ) :
                                        (
                                            <>

                                                <a href={`https://t.me/${botUsername}?start=login_k_${tmeLoginStr}`} className={style.connectTelegramButton}>Connect Telegram</a>
                                            </>
                                        )
                                }


                            </div>
                            {
                                userData?.user_type == "Agent" ? (
                                    <>
                                        <div className={style.userDataFormData}>
                                            <label htmlFor="" className={style.userDataFormData_label}>
                                                <p>Referral Link</p>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M1.33333 10.6667H2.28333L8.8 4.15L7.85 3.2L1.33333 9.71667V10.6667ZM0 12V9.16667L8.8 0.383333C8.93333 0.261111 9.08056 0.166667 9.24167 0.1C9.40278 0.0333333 9.57222 0 9.75 0C9.92778 0 10.1 0.0333333 10.2667 0.1C10.4333 0.166667 10.5778 0.266667 10.7 0.4L11.6167 1.33333C11.75 1.45556 11.8472 1.6 11.9083 1.76667C11.9694 1.93333 12 2.1 12 2.26667C12 2.44444 11.9694 2.61389 11.9083 2.775C11.8472 2.93611 11.75 3.08333 11.6167 3.21667L2.83333 12H0ZM8.31667 3.68333L7.85 3.2L8.8 4.15L8.31667 3.68333Z" fill="#A4AFB8" />
                                                </svg>
                                            </label>
                                            <p id='referLink' style={{ display: "none" }}>{`${webUrl}/signup/?ref=${userData?.refer_code}`}</p>
                                            <input type="text" value={`${webUrl}/signup/?ref=${userData?.refer_code}`} style={{ cursor: "pointer", userSelect: "none" }} readOnly onClick={(e) => { e.preventDefault(); handleCopy("referLink"); }} />
                                        </div>
                                    </>
                                ) : (
                                    <>

                                    </>
                                )
                            }

                        </form>


                    </div>



                    {
                        userData?.user_type == "Agent" ? (
                            <>
                                <div className={style.section1}>
                                    <div className={style.currentPlan}>
                                        <p className={style.currentPlanTitle}>
                                            Current Plan
                                        </p>

                                        <div className={style.currentPlanCard}>

                                            <div className={style.packDetails}>
                                                <div>
                                                    <div className={style.cardTitle} style={{ whiteSpace: "wrap", width: "100%" }}>
                                                        {

                                                            userData?.package ?
                                                                (
                                                                    <div >
                                                                        <p>Current Plan</p>
                                                                        <span className={style.cardTitle_packageType}>{userData.package.name}</span>

                                                                    </div>

                                                                ) :
                                                                (
                                                                    <div >
                                                                        <p className={style.cardTitle_noPlanActive}>No Plans Activated</p>
                                                                        <span className={style.cardTitle_packageType}>{agentPackages[0].name} :

                                                                            <div className={style.amount}>
                                                                                <p>{agentPackages[0].price} USD</p>
                                                                                {/* <span>(-3%)</span> */}
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                )

                                                        }
                                                    </div>
                                                </div>

                                            </div>


                                            <ul className={style.ul1}>
                                                <li>1 month of free access to all picks.</li>
                                            </ul>
                                            <div className={style.card_1m}>
                                                <p className={style.t1}>
                                                    After the 1st month
                                                </p>
                                                <ul className={style.ul2}>
                                                    <li>5 picks per day.</li>
                                                    <li>DayPass: 99 USD .</li>
                                                    <li>WeekPass: 299 USD .</li>
                                                    <li>MonthPass: 699 USD .</li>
                                                </ul>
                                            </div>
                                            {/* {
                                                userData?.package && userData?.package != "IMPERIAL" ?
                                                    (<>
                                                        <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('package', 3); }}>
                                                            Upgrade Plan

                                                        </div>

                                                    </>) :


                                                    (<>
                                                        <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('package', 1); }}>
                                                            Buy a Package

                                                        </div>

                                                    </>)
                                            } */}

                                        </div>
                                    </div>


                                </div>


                                <h1 className={style.userPackageTitle}>
                                    Upgrade Your Agent Package
                                </h1>


                                <div className={style.allPackages}>
                                    {
                                        agentPackages.map((_pack) => {
                                            return <>

                                                <div>

                                                    <div
                                                        className={style.pack}

                                                    >


                                                        <p className={style.packTitle}  >{_pack.name}</p>
                                                        <p className={style.packPrice}  >( only at {_pack.price} $ )</p>



                                                        <>
                                                            <div className={style.packsTexts1}>
                                                                <p className={style.pt_title}>Unlock new road</p>
                                                                <ul className={style.pt_ul}>
                                                                    <li>{_pack.title} </li>

                                                                </ul>
                                                            </div>
                                                        </>





                                                        <p className={style.packT1}>
                                                            🔓 Unlock 5 expert picks every day! Stay ahead of the game with insights tailored to maximize your winnings.
                                                        </p>

                                                        <div className={style.hrLine}></div>


                                                        <p className={style.packT2} dangerouslySetInnerHTML={{ __html: _pack.description }}></p>

                                                        {/* <ul className={style.pt_ul2}>
                                                            <li>Access to all Daily Picks</li>
                                                            <li>Weekly Profit Boost</li>
                                                            <li>Maximize Your Winnings</li>
                                                            <li>Expert Picks Daily</li>
                                                            <li>Dominate the Game</li>
                                                        </ul> */}

                                                        {
                                                            userData.package?.name == _pack.name ? (
                                                                <div className={style.upgradeButton} style={{ backgroundColor: "#BCC0BC" }}>
                                                                    Current Plan
                                                                </div>
                                                            ) : (

                                                                <>

                                                                    <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('agent_package', Number(_pack.pk)); }} style={{ marginTop: "20px" }}>
                                                                        Upgrade
                                                                    </div>


                                                                </>

                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        })
                                    }
                                </div>


                            </>
                        ) :
                            (
                                <>


                                </>
                            )
                    }




                    {
                        allPackages.length > 0 ? (
                            <div style={{ width: "100vw", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <h1 className={style.userPackageTitle}>
                                    Buy Package Passes 
                                </h1>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    <div className={style.allPackages}>
                        
                        {
                            allPackages.map((packagePass) => {
                                return <>


                                    {
                                        !packagePass.fields.top_selling ? (
                                            <>
                                                <div className={style.pack}>
                                                    <p className={style.packTitle}>{formatTitleText(packagePass.fields.package_type)}</p>
                                                    <p className={style.packPrice}>( only at {packagePass.fields.price} $ )</p>

                                                    {/* {
                                                        packagePass.fields.name == "DAILY_PASS" ? (
                                                            <>
                                                                <div className={style.packsTexts1}>
                                                                    <p className={style.pt_title}>Unlock new road</p>
                                                                    <ul className={style.pt_ul}>
                                                                        <li>Get all the picks in a Day </li>
                                                                        <li>Earn More</li>
                                                                        <li>Look inside Michis Picks</li>
                                                                    </ul>
                                                                </div>
                                                            </>
                                                        ) : (<></>)

                                                    } */}



                                                    <p className={style.packT1}>
                                                        🔓 Unlock 5 expert picks every day! Stay ahead of the game with insights tailored to maximize your winnings.
                                                    </p>

                                                    <div className={style.hrLine}></div>


                                                    <p className={style.packT2}>
                                                        {packagePass.fields.title}
                                                    </p>

                                                    <ul className={style.pt_ul2}>
                                                        <li dangerouslySetInnerHTML={{ __html: packagePass.fields.description }}></li>
                                                    </ul>
                                                            {
                                                                activePackages.some(pkg => pkg.fields.package == packagePass.pk) ? <>
                                                                <div className={style.upgradeButton} style={{ backgroundColor: "#BCC0BC" }}>
                                                                    Active 
                                                                </div>
                                                                </> : <>
                                                                    <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('package',packagePass.pk)}}>
                                                                        Upgrade 
                                                                    </div>
                                                                </>
                                                            }
                                                </div>
                                            </>
                                        ) :
                                            (
                                                <>
                                                    <div className={style.topSellingContainer}>
                                                        <div className={style.topSelling}>Top Selling</div>
                                                        <div className={`${style.pack} ${style.topSellingPack}`}>


                                                            <p className={style.packTitle}>{formatTitleText(packagePass.fields.package_type)}</p>
                                                            <p className={style.packPrice}>( only at {packagePass.fields.price} $ )</p>
                                                            {/* 
                                                            {
                                                                packagePass.fields.name == "DAILY_PASS" ? (
                                                                    <>
                                                                        <div className={style.packsTexts1}>
                                                                            <p className={style.pt_title}>Unlock new road</p>
                                                                            <ul className={style.pt_ul}>
                                                                                <li>Get all the picks in a Day </li>
                                                                                <li>Earn More</li>
                                                                                <li>Look inside Michis Picks</li>
                                                                            </ul>
                                                                        </div>
                                                                    </>
                                                                ) : (<></>)

                                                            } */}


                                                            <p className={style.packT1}>
                                                                🔓 Unlock 5 expert picks every day! Stay ahead of the game with insights tailored to maximize your winnings.
                                                            </p>

                                                            <div className={style.hrLine}></div>


                                                            <p className={style.packT2}>
                                                                💥 Upgrade to the Premium Pack for just $899 and enjoy 6 daily picks,
                                                            </p>

                                                            <ul className={style.pt_ul2}>
                                                                <li></li>
                                                            </ul>
                                                            {
                                                                 activePackages.some(pkg => pkg.fields.package == packagePass.pk)? <>
                                                                <div className={style.upgradeButton} style={{ backgroundColor: "#BCC0BC" }}>
                                                                    Active
                                                                </div>
                                                                </> : <>
                                                                    <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan('package',packagePass.pk)}}>
                                                                        Upgrade
                                                                    </div>
                                                                </>
                                                            }

                                                        </div>
                                                    </div>
                                                </>
                                            )
                                    }

                                </>
                            })
                        }
                    </div>


                </div>

            </div>
        </>
    );
};

export default DashBoardPage;